/**
 * Cart Price Updater
 * Updates cart prices to reflect the total calculated price from the product builder
 * Looks for "Total Price" property and updates all money spans accordingly
 */

document.addEventListener('DOMContentLoaded', function() {
  updateCartPrices();
});

function updateCartPrices() {
  console.log('Starting cart price update...');
  
  // Find all cart items (both regular cart and AJAX cart)
  const cartItems = document.querySelectorAll('.cart__card[data-cart-item], .ajax-cart__item');
  
  let hasCustomPricing = false;
  
  cartItems.forEach((item, index) => {
    console.log(`Processing cart item ${index + 1}...`);
    
    // Look for the "Total Price" property in this cart item
    const totalPriceProperty = findTotalPriceProperty(item);
    
    if (totalPriceProperty) {
      const totalPrice = extractPriceFromText(totalPriceProperty);
      console.log(`Found total price for item ${index + 1}: ${totalPrice}`);
      
      if (totalPrice) {
        updateCartItemPrices(item, totalPrice);
        hasCustomPricing = true;
      }
    } else {
      console.log(`No total price property found for item ${index + 1} - using Shopify native pricing`);
    }
  });
  
  // Only update cart subtotal if we have custom pricing, otherwise let Shopify handle it
  if (hasCustomPricing) {
    updateCartSubtotal();
    console.log('Updated cart with custom pricing');
  } else {
    console.log('No custom pricing found - letting Shopify handle cart calculations');
  }
}

function findTotalPriceProperty(cartItem) {
  // Look for the "Total Price" property in the cart options
  const productOptions = cartItem.querySelectorAll('.cart__product-option, .ajax-cart__option');
  
  for (const option of productOptions) {
    const optionName = option.querySelector('.cart__product-option-name, .ajax-cart__option-name');
    if (optionName && optionName.textContent.includes('Total Price')) {
      const optionValue = option.querySelector('.cart__product-option-value, .ajax-cart__option-value');
      return optionValue ? optionValue.textContent.trim() : null;
    }
  }
  
  // Also check for any element that contains "Total Price:"
  const allElements = cartItem.querySelectorAll('*');
  for (const element of allElements) {
    if (element.textContent.includes('Total Price:')) {
      // Try to find the value part
      const text = element.textContent;
      const match = text.match(/Total Price:\s*(.+?)(?:\n|$)/);
      if (match) {
        return match[1].trim();
      }
    }
  }
  
  return null;
}

function extractPriceFromText(priceText) {
  // Extract price from text like "$1,898.00"
  const priceMatch = priceText.match(/\$?([\d,]+\.?\d*)/);
  return priceMatch ? priceMatch[1] : null;
}

function formatPrice(price) {
  // Use the theme's price formatting function if available
  if (window.PXUTheme && window.PXUTheme.currency) {
    if (window.PXUTheme.currency.display_format === 'money_with_currency_format') {
      return `<span class="money">${window.PXUTheme.currency.symbol}${price} ${window.PXUTheme.currency.iso_code}</span>`;
    } else {
      return `<span class="money">${window.PXUTheme.currency.symbol}${price}</span>`;
    }
  } else {
    // Fallback formatting
    return `<span class="money">$${price}</span>`;
  }
}

function updateCartItemPrices(cartItem, totalPrice) {
  console.log(`Updating prices for cart item to: $${totalPrice}`);
  
  // Find all money spans in this cart item that need updating
  const priceElements = cartItem.querySelectorAll('.cart__price .money, .cart__total .money, .ajax-cart__price .money, .ajax-cart__total .money, .money');
  
  priceElements.forEach(element => {
    // Don't update the Total Price property itself, only the actual price displays
    const parentText = element.parentElement ? element.parentElement.textContent : '';
    if (parentText.includes('Total Price:')) {
      return; // Skip this one
    }
    
    const formattedPrice = formatPrice(totalPrice);
    element.outerHTML = formattedPrice;
    console.log(`Updated price element: ${formattedPrice}`);
  });
  
  // Also update any line item data attributes if needed
  const cartItemElement = cartItem.closest('[data-cart-item]') || cartItem;
  if (cartItemElement) {
    // Store the updated price as a data attribute for future reference
    cartItemElement.dataset.updatedPrice = totalPrice;
  }
}

function updateCartSubtotal() {
  console.log('Updating cart subtotal...');
  
  // Calculate new subtotal from all updated prices
  let newSubtotal = 0;
  let hasCustomPricing = false;
  const cartItems = document.querySelectorAll('.cart__card[data-cart-item], .ajax-cart__item');
  
  cartItems.forEach(item => {
    const quantity = getCartItemQuantity(item);
    let itemPrice = 0;
    
    // Check if we have an updated price
    if (item.dataset.updatedPrice) {
      itemPrice = parseFloat(item.dataset.updatedPrice.replace(/,/g, ''));
      hasCustomPricing = true;
    } else {
      // Fall back to reading from the total price property
      const totalPriceProperty = findTotalPriceProperty(item);
      if (totalPriceProperty) {
        const priceStr = extractPriceFromText(totalPriceProperty);
        itemPrice = parseFloat(priceStr.replace(/,/g, ''));
        hasCustomPricing = true;
      }
    }
    
    newSubtotal += itemPrice * quantity;
  });
  
  // Only update subtotal if we found custom pricing, otherwise let Shopify handle it
  if (hasCustomPricing) {
    console.log(`New subtotal calculated: $${newSubtotal.toFixed(2)}`);
    
    // Update subtotal display (both regular cart and AJAX cart)
    const subtotalElements = document.querySelectorAll('.cart__subtotal .money, .ajax-cart__subtotal .money, [class*="subtotal"] .money');
    subtotalElements.forEach(element => {
      const formattedSubtotal = formatPrice(newSubtotal.toFixed(2));
      element.outerHTML = formattedSubtotal;
      console.log(`Updated subtotal: ${formattedSubtotal}`);
    });
  } else {
    console.log('No custom pricing found - not overriding Shopify subtotal calculation');
  }
}

function getCartItemQuantity(cartItem) {
  const quantityInput = cartItem.querySelector('.quantity-input, .ajax-cart__quantity input, [name*="quantity"]');
  return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
}

// Listen for quantity changes to update subtotal
document.addEventListener('change', function(e) {
  if (e.target && e.target.classList.contains('quantity-input')) {
    console.log('Quantity changed, updating subtotal...');
    setTimeout(updateCartSubtotal, 100); // Small delay to ensure DOM is updated
  }
});

// Listen for cart updates (AJAX cart changes)
document.addEventListener('cart:updated', function() {
  console.log('Cart updated, refreshing prices...');
  setTimeout(updateCartPrices, 500); // Delay to ensure cart DOM is updated
});

// Listen for AJAX cart refresh/rebuild events
document.addEventListener('cart:refresh', function() {
  console.log('Cart refreshed, updating prices...');
  setTimeout(updateCartPrices, 500);
});

// Listen for drawer cart events
document.addEventListener('cart:build', function() {
  console.log('Cart built, updating prices...');
  setTimeout(updateCartPrices, 500);
});

// Also listen for Shopify's cart refresh events
if (window.Shopify && window.Shopify.onCartUpdate) {
  const originalOnCartUpdate = window.Shopify.onCartUpdate;
  window.Shopify.onCartUpdate = function(cart) {
    if (originalOnCartUpdate) {
      originalOnCartUpdate(cart);
    }
    setTimeout(updateCartPrices, 500);
  };
}

// Listen for AJAX cart drawer opening
document.addEventListener('click', function(e) {
  if (e.target.closest('[data-ajax-cart-trigger]') || 
      e.target.closest('.ajax-cart-trigger') ||
      e.target.closest('[href*="cart"]')) {
    setTimeout(updateCartPrices, 1000); // Longer delay for drawer opening
  }
});

// MutationObserver to detect when cart content is dynamically loaded
let cartObserver;
function observeCartChanges() {
  const cartContainer = document.querySelector('.cart-section, .ajax-cart, [id*="cart"], [class*="cart"]');
  
  if (cartContainer && !cartObserver) {
    cartObserver = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if cart items were added
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (
                node.classList.contains('cart__card') ||
                node.querySelector && node.querySelector('.cart__card') ||
                node.classList.contains('ajax-cart__item') ||
                node.querySelector && node.querySelector('.ajax-cart__item')
            )) {
              shouldUpdate = true;
            }
          });
        }
      });
      
      if (shouldUpdate) {
        console.log('Cart DOM changed, updating prices...');
        setTimeout(updateCartPrices, 300);
      }
    });
    
    cartObserver.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
}

// Start observing after DOM is ready
setTimeout(observeCartChanges, 1000);

// Make functions globally accessible for debugging
window.updateCartPrices = updateCartPrices;
window.debugCartPrices = function() {
  console.log('=== CART PRICE DEBUG ===');
  
  const cartItems = document.querySelectorAll('.cart__card[data-cart-item], .ajax-cart__item');
  console.log(`Found ${cartItems.length} cart items`);
  
  cartItems.forEach((item, index) => {
    const totalPriceProperty = findTotalPriceProperty(item);
    const quantity = getCartItemQuantity(item);
    const updatedPrice = item.dataset.updatedPrice;
    const moneyElements = item.querySelectorAll('.money');
    
    console.log(`Item ${index + 1}:`, {
      totalPriceProperty,
      quantity,
      updatedPrice,
      moneyElements: moneyElements.length,
      isAjaxCart: item.classList.contains('ajax-cart__item'),
      hasCartCard: item.classList.contains('cart__card')
    });
    
    // Show all money elements in this item
    moneyElements.forEach((money, i) => {
      console.log(`  Money element ${i + 1}:`, money.textContent, 'in:', money.parentElement.className);
    });
  });
  
  // Show cart structure
  console.log('Cart structure:', {
    regularCartItems: document.querySelectorAll('.cart__card[data-cart-item]').length,
    ajaxCartItems: document.querySelectorAll('.ajax-cart__item').length,
    totalPriceProperties: document.querySelectorAll('*').length // Count all elements containing "Total Price"
  });
};

console.log('Cart price updater loaded');
